import { getClient } from 'utils/ContentfulClient';

const getTagIds = (c) => c.metadata.tags.map((tag) => tag.sys.id);

const fetchLogos = async () => {
  const contentful = await getClient();

  const entries = await contentful.getEntries({
    content_type: 'branded',
    'fields.entryTitle': 'Logo',
  });

  const entry = entries.items[0];

  if (!entry) {
    throw new Error('No Branded content found with name "Logo"');
  }

  const logos = entry.fields.media.map((logo) => ({
    tags: getTagIds(logo),
    ...logo.fields,
  }));

  return logos;
};

let LOGOS;

const getOrFetchLogos = () => {
  if (LOGOS) return LOGOS;
  LOGOS = fetchLogos();
  return LOGOS;
};

export const getLogosByTag = async (tag) => {
  const logos = await getOrFetchLogos();
  return logos.filter((logo) => logo.tags.includes(tag));
};
